/**
 * @generated SignedSource<<935a39b4715311dc750e840d3ca2a5b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutEmailOnlyShippingForm_viewer$data = {
  readonly __typename: "Viewer";
  readonly enableCheckoutAddressAutocomplete: boolean | null;
  readonly enableEmailOnlyCheckoutModalOnBlur: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutRegistrationForm_viewer" | "CheckoutRegistrationMarketingOptIn_viewer" | "ControlledAddressForm_viewer">;
  readonly " $fragmentType": "CheckoutEmailOnlyShippingForm_viewer";
};
export type CheckoutEmailOnlyShippingForm_viewer$key = {
  readonly " $data"?: CheckoutEmailOnlyShippingForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutEmailOnlyShippingForm_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutEmailOnlyShippingForm_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRegistrationForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ControlledAddressForm_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutRegistrationMarketingOptIn_viewer"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": "enableEmailOnlyCheckoutModalOnBlur",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "emailOnlyCheckoutModalOnBlur"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"emailOnlyCheckoutModalOnBlur\")"
    },
    {
      "alias": "enableCheckoutAddressAutocomplete",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "checkoutAddressAutocomplete"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"checkoutAddressAutocomplete\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "be17640eadb222e17b0f759408a0b414";

export default node;
